// extracted by mini-css-extract-plugin
export var head = "head-module--head--1VAMm";
export var is_hide = "head-module--is_hide--3hl2C";
export var appHead = "head-module--appHead--jdGte";
export var mobileVideo = "head-module--mobileVideo--2YYyN";
export var news = "head-module--news--1mVOz";
export var newsList = "head-module--newsList--2Qg9w";